import type { ReactNode } from 'react';
import type { Access } from './access';
import { useRoleAccess } from './use-role-access';

type Props = Access & { children: ReactNode };

/**
 * Renders `children` only when the caller's role may do (`feature`, `op`).
 * Role-blocked controls are HIDDEN — not disabled, no lock, no CTA. Renders
 * nothing while the role is unresolved.
 */
export function RoleGate({ feature, op, children }: Props) {
  const { allowed } = useRoleAccess({ feature, op });
  return allowed ? <>{children}</> : null;
}
